import { Link, useLocation } from "react-router-dom";
import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { useBreadcrumb } from "../../context/BreadcrumbContext";

const formatSegment = (segment) => {
  return segment
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const HIDDEN_SEGMENTS = ["documentos"];

const SEGMENT_LABELS = {
  transparencia: "Portal da Transparência",
};

const renderCrumbs = (crumbs) => (
  <nav aria-label="Navegação estrutural" className="py-3 text-sm">
    <ol className="flex flex-wrap items-center gap-1 text-gray-500">
      {crumbs.map((crumb, index) => (
        <li key={crumb.path ?? crumb.label} className="flex items-center gap-1">
          {index > 0 && (
            <ChevronRightIcon className="h-3.5 w-3.5 text-gray-400 flex-shrink-0" />
          )}
          {index < crumbs.length - 1 && crumb.path ? (
            <Link
              to={crumb.path}
              className="text-blue-700 hover:text-blue-900 hover:underline"
            >
              {crumb.label}
            </Link>
          ) : (
            <span className="font-medium text-gray-800">{crumb.label}</span>
          )}
        </li>
      ))}
    </ol>
  </nav>
);

const Breadcrumb = () => {
  const { pathname } = useLocation();
  const { extraCrumbs } = useBreadcrumb();

  if (!pathname.startsWith("/transparencia/")) return null;

  if (extraCrumbs && extraCrumbs.forPath === pathname) {
    return renderCrumbs(extraCrumbs.crumbs);
  }

  const segments = pathname.split("/").filter(Boolean);

  const crumbs = [];
  segments.forEach((segment, index) => {
    if (!isNaN(segment)) return;
    if (HIDDEN_SEGMENTS.includes(segment)) return;
    crumbs.push({
      path: "/" + segments.slice(0, index + 1).join("/"),
      label: SEGMENT_LABELS[segment] ?? formatSegment(decodeURIComponent(segment)),
    });
  });

  return renderCrumbs(crumbs);
};

export default Breadcrumb;
